import { config } from './config';
import type { StyleText } from './types';

export async function getStyles(): Promise<StyleText> {
  const resp = await fetch(`${config.static.public_base_url}/style.json`, {
    method: 'GET',
  });

  return await resp.json();
}

export async function getManifest(): Promise<string[]> {
  const resp = await fetch(
    `${config.static.public_base_url}/assets/manifest.json`,
    {
      method: 'GET',
    },
  );
  return await resp.json();
}
